







  import Vue from 'vue';
import QuestionModal from './question-modal.vue';

  export default Vue.extend({
    components: { QuestionModal }
});
